"use client";
import { j as m } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as n, useContext as c } from "react";
import { b as i } from "./Table.style-CZNieSq3.mjs";
import { T as f } from "./TableContext-DbkGJo7V.mjs";
const u = n(
  function(e, s) {
    const { isHeader: o, size: l } = c(f), {
      component: t = o ? "th" : "td",
      className: r,
      ...a
    } = e;
    return /* @__PURE__ */ m.jsx(
      t,
      {
        ref: s,
        className: i({
          size: l,
          td: t === "td",
          th: t === "th",
          class: r
        }),
        ...a
      }
    );
  }
);
export {
  u as TableCell
};
